import { render } from "./MySeasons.vue?vue&type=template&id=79c1936d&scoped=true"
import script from "./MySeasons.vue?vue&type=script&lang=js"
export * from "./MySeasons.vue?vue&type=script&lang=js"

import "./MySeasons.vue?vue&type=style&index=0&id=79c1936d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c1936d"]])

export default __exports__